import countTo from 'vue-count-to';
export default {
  name: 'cardList',
  components: {
    countTo
  },
  props: {
    aggregate: {
      type: Array,
      default() {
        return [];
      }
    },
    panelData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    sendTitle(title, key) {
      this.$emit('sendTitle', title, key);
    }
  }
};